export default "\n        <app-locations-list></app-locations-list>\n";